import { useEffect, useState } from 'react';
import { useLoading } from '../context/QueryLoadingContext';

async function getHomePageContent(pageName) {
  const f = await fetch(`${process.env.DIRECTUS_URI}graphql/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `query ($pageName: String!) {
        home_page (filter: { id: { _eq: $pageName } }) {
          id,
          sections_order {
            home_page_sections_id {
              id
            }
          },
          header_items,
          home_title,
          home_subtitle,
          home_button,
          home_background {
              id
          },
          home_content_size,
          insurances_pretitle,
          insurances_title
          insurances_subtitle,
          service_pretitle,
          service_title,
          service_subtitle,
          hiw_pretitle,
          hiw_title,
          hiw_subtitle,
          hiw_steps,
          faq_questions {
            faq_questions_id {
              title,
              content
            }
          },
          aboutus_pretitle,
          aboutus_title,
          aboutus_subtitle,
          reviews_pretitle,
          reviews_title,
          reviews_subtitle
        }
      }`,
      variables: {
        pageName,
      },
    }),
  });
  const res = await f.json();

  return (!res.data || res.data.home_page.length === 0) ? null : res.data.home_page[0];
}

async function getHeaderItems(pageName) {
  const f = await fetch(`${process.env.DIRECTUS_URI}graphql/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `query ($pageName: String!) {
        home_page (filter: { id: { _eq: $pageName } }) {
          header_items
        }
      }`,
      variables: {
        pageName,
      },
    }),
  });
  const res = await f.json();

  return (!res.data || res.data.home_page.length === 0) ? null : res.data.home_page[0].header_items;
}

export function useHomePagePreview(pageName) {
  const [content, setContent] = useState(null);
  const { loading, setLoading } = useLoading();

  useEffect(() => {
    setLoading(true);

    getHomePageContent(pageName).then((data) => {
      setContent(data);
      setLoading(false);
    });
  }, []);

  return { loading, content };
}

export function useHeaderItemsPreview(pageName) {
  const [headerItems, setHeaderItems] = useState(null);
  const { loading, setLoading } = useLoading();

  useEffect(() => {
    if (!pageName) return;

    setLoading(true);

    getHeaderItems(pageName).then((data) => {
      setHeaderItems(data);
      setLoading(false);
    });
  }, [pageName]);

  return { loading, headerItems };
}
